<template>
  <div class="summary-grid">
    <div class="summary-item">
      <h4>{{ totalCampaigns }}</h4>
      <p>{{ $t('CAMPAIGNS_REPORT.SUMMARY.CAMPAIGNS') }}</p>
    </div>
    <div class="summary-item">
      <h4>{{ totalMessages }}</h4>
      <p>{{ $t('CAMPAIGNS_REPORT.SUMMARY.MESSAGES') }}</p>
    </div>
    <div class="summary-item">
      <h4>{{ countByStatus['1 check do WhatsApp'] || 0 }}</h4>
      <p>{{ $t('CAMPAIGNS_REPORT.SUMMARY.ONE_CHECK') }}</p>
    </div>
    <div class="summary-item">
      <h4>{{ countByStatus['2 checks do WhatsApp'] || 0 }}</h4>
      <p>{{ $t('CAMPAIGNS_REPORT.SUMMARY.TWO_CHECKS') }}</p>
    </div>
    <div class="summary-item">
      <h4>{{ countByStatus['2 checks verdes do WhatsApp'] || 0 }}</h4>
      <p>{{ $t('CAMPAIGNS_REPORT.SUMMARY.TWO_GREEN_CHECKS') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignsSummary',
  props: {
    messages: {
      type: Array,
      required: true,
    },
  },
  computed: {
    totalCampaigns() {
      const uniqueTitles = new Set(this.messages.map(m => m.campaign_title));
      return uniqueTitles.size;
    },
    totalMessages() {
      return this.messages.length;
    },
    countByStatus() {
      return this.messages.reduce((acc, item) => {
        const key = item.status_message;
        if (!acc[key]) acc[key] = 0;
        acc[key]++;
        return acc;
      }, {});
    },
  },
};
</script>

<style scoped>
.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 20px;
  margin-bottom: 16px;
}

.summary-item {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.summary-item h4 {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

.summary-item p {
  margin: 4px 0 0;
  font-size: 14px;
  color: #555;
}
</style>
